import React from "react";

export const CarouselButtonPreviousIcon = ({ fill = "#000" }: { fill?: string }) => (
  <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.68907 0.315696C7.10364 0.734816 7.10364 1.41186 6.68907 1.83097L2.56454 6.00068L6.68907 10.1704C7.10364 10.5895 7.10364 11.2665 6.68907 11.6857C6.27449 12.1048 5.60478 12.1048 5.1902 11.6857L0.310934 6.75294C-0.103645 6.33382 -0.103645 5.65679 0.310934 5.23767L5.1902 0.30495C5.59415 -0.103423 6.27449 -0.103423 6.68907 0.315696Z"
      fill={fill}
      fillOpacity="0.54"
    />
  </svg>
);
